module.exports = __webpack_public_path__ + "img/smart0.a66b59d8.png";